'use strict';

var tslib = require('tslib');
var React = require('react');
var index = require('./index-b4aa8bee.js');
require('events');
require('react/jsx-runtime');
require('@emotion/react');
require('react-dom');
require('react-intl');
require('react-hook-form');

/** https://mui.com/components/radio-buttons/ */
const RadioGroup = React.forwardRef((_a, ref) => {
    var { InputLabelProps, HelperTextProps, FormControlProps, disabled, error, focused, helperText, id, items, label, name, value, options, required } = _a, props = tslib.__rest(_a, ["InputLabelProps", "HelperTextProps", "FormControlProps", "disabled", "error", "focused", "helperText", "id", "items", "label", "name", "value", "options", "required"]);
    const inputId = id !== null && id !== void 0 ? id : `${name}_input`;
    const labelId = `${name}_label`;
    const helperTextId = `${name}_helperText`;
    return (React.createElement(index.MultiThemeProvider, null, (themeName) => (React.createElement(index.MuiFormControl, Object.assign({}, FormControlProps),
        label && (React.createElement(index.InputLabel, Object.assign({}, InputLabelProps, { id: labelId, error: error, focused: focused, disabled: disabled, required: required, htmlFor: inputId, readOnly: props.readOnly }), label)),
        React.createElement(index.MuiRadioGroup, Object.assign({}, props, { ref: ref, value: value, "aria-describedby": helperTextId, "aria-labelledby": labelId }), (options || items || []).map((radioItem, idx) => {
            var _a;
            const isDisabled = radioItem.disabled || disabled;
            return (React.createElement(index.FormControlLabel, { key: idx, checked: radioItem.checked || value === radioItem.value, value: (_a = radioItem.value) !== null && _a !== void 0 ? _a : value, disabled: isDisabled, control: React.createElement(index.Radio, Object.assign({}, radioItem, { disabled: isDisabled })), label: radioItem.label, sx: radioItem.sx }));
        })),
        React.createElement(index.FormHelperText, Object.assign({}, HelperTextProps, { id: helperTextId, "data-testid": 'helperText', disabled: disabled, error: error, required: required }), index.determineHelperText({ themeName, required, helperText }))))));
});
RadioGroup.displayName = 'RadioGroup';
RadioGroup.defaultProps = {
    color: 'primary',
    items: [],
};

exports.default = RadioGroup;
